// The core speaks exactly one bbox dialect: [x, y, width, height] in the
// source image's own pixel coordinates. Adapters convert on the way in --
// deliberately, so the panel never carries a format flag. (toseftasite's
// emitted JSON stores [x0, y0, x1, y1]; taanticMidrashimDig's stores
// [x, y, w, h] already.)

export function fromXYXY(b) {
    if (!b || b.length < 4) return null;
    const [x0, y0, x1, y1] = b;
    return [x0, y0, x1 - x0, y1 - y0];
}

export function fromXYWH(b) {
    if (!b || b.length < 4) return null;
    return [b[0], b[1], b[2], b[3]];
}

// Percentage geometry for absolutely positioning the highlight over a
// percentage-sized image. Percentages (rather than pixels) are what let the
// zoom implementation resize the wrapper and have the box follow for free.
export function toPercentStyle(bbox, page) {
    if (!bbox || !page || !page.width || !page.height) return null;
    return {
        left: (bbox[0] / page.width * 100) + '%',
        top: (bbox[1] / page.height * 100) + '%',
        width: (bbox[2] / page.width * 100) + '%',
        height: (bbox[3] / page.height * 100) + '%',
    };
}

// A polygon (a line's mask, from PAGE-XML Coords) as an SVG `points` string in
// the viewBox set up by `polygonViewBox` below -- i.e. percentages of the page,
// so it scales with the wrapper exactly as the percentage-positioned boxes do.
//
// Accepts the three shapes adapters actually hold: [[x, y], ...],
// [{x, y}, ...] and a flat [x0, y0, x1, y1, ...] (PAGE-XML's own dialect).
export function polygonPoints(poly, page) {
    const pts = normalizePolygon(poly);
    if (!pts || pts.length < 3 || !page || !page.width || !page.height) return null;
    return pts
        .map(([x, y]) => round4(x / page.width * 100) + ',' + round4(y / page.height * 100))
        .join(' ');
}

export function normalizePolygon(poly) {
    if (!Array.isArray(poly) || !poly.length) return null;
    const first = poly[0];
    let pts;
    if (Array.isArray(first)) {
        pts = poly.map(p => [Number(p[0]), Number(p[1])]);
    } else if (first && typeof first === 'object') {
        pts = poly.map(p => [Number(p.x), Number(p.y)]);
    } else {
        // flat [x0, y0, x1, y1, ...]
        if (poly.length < 6 || poly.length % 2) return null;
        pts = [];
        for (let i = 0; i < poly.length; i += 2) pts.push([Number(poly[i]), Number(poly[i + 1])]);
    }
    return pts.every(p => Number.isFinite(p[0]) && Number.isFinite(p[1])) ? pts : null;
}

const round4 = n => Math.round(n * 1e4) / 1e4;
